import { render, staticRenderFns } from "./WrenwoodHeader.vue?vue&type=template&id=036abbac&scoped=true"
import script from "./WrenwoodHeader.vue?vue&type=script&setup=true&lang=ts"
export * from "./WrenwoodHeader.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./WrenwoodHeader.vue?vue&type=style&index=0&id=036abbac&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "036abbac",
  null
  
)

export default component.exports